/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { baseRequest } from './baseRequest';
import { handleAxiosRequest } from 'blb-api/requestHelper';
const baseRoute = '/api/internal/ron';
export const downloadNotaryCredentialFile = async (principalId, credentialId) => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users/${principalId}/credentials/${credentialId}/download`, {
    headers: {
      accept: 'application/pdf'
    },
    responseType: 'blob'
  });
  return data;
};
export const fetchNotaryList = async opts => {
  const {
    limit,
    offset,
    status,
    search
  } = opts;
  const statusParam = status ? `&status=${status}` : '';
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users?limit=${limit}&offset=${offset}${statusParam}${searchParam}`);
  return data;
};
export const getNotaryCountsByStatus = async () => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users/countsByStatus`);
  return data;
};
export const inviteNotary = async request => {
  await baseRequest.post(`${baseRoute}/user/invite-notary`, request);
};
export const getUserCredentials = async principalId => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users/${principalId}/credentials`);
  return data.map(credential => ({
    ...credential,
    createdAt: new Date(credential.createdAt)
  }));
};
export const getUserCredentialDetails = async (principalId, credentialId) => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users/${principalId}/credentials/${credentialId}/details`);
  return data;
};
export const addCredentialReview = async (principalId, credentialId, reviewType, adminNotes) => {
  await baseRequest.post(`${baseRoute}/proxy/admin/users/${principalId}/credentials/${credentialId}/review`, {
    action: reviewType,
    adminNotes
  });
};
export const patchUserStatus = async (principalId, status) => {
  const {
    data
  } = await baseRequest.patch(`${baseRoute}/proxy/admin/users/${principalId}/status`, {
    status
  });
  return data;
};
export const getRONUser = async principalId => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/admin/users/${principalId}`);
  return data;
};
export const getCurrentUserCredentials = async () => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/user/credentials`);
  return data.map(credential => ({
    ...credential,
    createdAt: new Date(credential.createdAt)
  }));
};
export const downloadCredentialFileForCurrentUser = async credentialId => {
  const {
    data
  } = await baseRequest.get(`${baseRoute}/proxy/user/credentials/${credentialId}/download`, {
    headers: {
      accept: 'application/pdf'
    },
    responseType: 'blob'
  });
  return data;
};
export const patchCredential = async request => {
  return handleAxiosRequest(baseRequest.patch(`${baseRoute}/proxy/user/credentials`, request));
};
export const getCurrentUser = async () => {
  return handleAxiosRequest(baseRequest.get(`${baseRoute}/proxy/user`));
};

/** Flag user.pendingReview=true and notify admin that user requests an approval */
export const submitForApproval = async () => {
  return handleAxiosRequest(baseRequest.post(`${baseRoute}/proxy/user/submit-approval`));
};

/** Get the audit trail of user history */
export const getUserEvents = async () => {
  return handleAxiosRequest(baseRequest.get(`${baseRoute}/proxy/user/events`));
};
export const getGroupsForUser = async () => {
  return handleAxiosRequest(baseRequest.get(`${baseRoute}/proxy/admin/groups`));
};